document.addEventListener("DOMContentLoaded", function () {
  const excludedPages = [
    'https://www.ambraspirits.com.au/pages/join-the-club',
    'https://www.ambraspirits.com.au/pages/chance-to-win',
    'https://www.ambraspirits.com.au/pages/newsletter',
    'https://www.ambraspirits.com.au/pages/ctw-terms-conditions'
  ];

  function isExcludedPage() {
    return excludedPages.includes(window.location.href);
  }

  function checkAgeVerification() {
    const ageVerified = document.cookie.split('; ').find(row => row.startsWith('ageGateAuthenticated='));
    return ageVerified && ageVerified.split('=')[1] === 'true';
  }

  function showPopup() {
    const popup = document.getElementById('popup');
    const closeButton = document.getElementById('close-popup');

    popup.style.display = 'flex';

    closeButton.addEventListener('click', function () {
      popup.style.display = 'none';
      sessionStorage.setItem('popupShown', 'true');
    });
  }

  function waitForAgeVerification() {
    if (sessionStorage.getItem('popupShown') !== 'true') {
      if (checkAgeVerification()) {
        console.log("Age verified. Showing popup in 5 seconds.");
        setTimeout(showPopup, 5000);
      } else {
        console.log("Age not verified yet. Rechecking in 1 second.");
        setTimeout(waitForAgeVerification, 1000);
      }
    } else {
      console.log("Popup already shown this session.");
    }
  }

  if (!isExcludedPage()) {
    waitForAgeVerification();
  } else {
    console.log("Popup excluded on this page.");
  }
});
